import React from "react";
import posthog from "posthog-js";

class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    posthog?.capture("section_render_error", {
      section: this.props.name,
      error_name: error?.name,
      error_message: error?.message,
      component_stack: info?.componentStack?.slice(0, 1000),
    });
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default SectionErrorBoundary;
